import Header from "@/components/header-v2";
import useNavBar from "@/hooks/use-nav-bar";
import { cn } from "@/lib/utils";

import Actions from "./actions";
import MobileHeader from "./header";
import LeftSidebar from "./left-sidebar";
import ProfileHeader from "./profile-header";
import type { UserType } from "./types";

interface BlockedContentProps {
  user: UserType;
}

function BlockedContent({ user }: BlockedContentProps) {
  return (
    <div className="mt-[15px] flex flex-col items-stretch gap-[15px] md:mt-0">
      <p className="mt-[15px] rounded-[10px] bg-white/5 p-5 text-14/[1.7em] text-pale-lavender md:mt-0">
        You have blocked this user.
      </p>
      <div className="md:hidden">
        <Actions user={user} />
      </div>
    </div>
  );
}

interface LayoutProps {
  children: React.ReactNode;
  isProfileView?: boolean;
  title?: string;
  user: UserType;
}

export default function Layout({
  children,
  isProfileView = false,
  title,
  user,
}: LayoutProps) {
  useNavBar();

  return (
    <>
      <Header mobileClassName="hidden" variant="simplified" />
      <div className="container">
        <MobileHeader
          className="md:hidden"
          isProfileView={isProfileView}
          title={title}
          user={user}
        />
        <ProfileHeader
          className={cn(!isProfileView && "hidden md:flex")}
          user={user}
        />
        <div className="grid grid-cols-1 gap-20 pb-50 md:grid-cols-13">
          <div className="col-span-3 hidden md:block">
            <LeftSidebar user={user} />
          </div>
          <div className="md:col-span-10">
            {user.isBlocked ? <BlockedContent user={user} /> : children}
          </div>
        </div>
      </div>
    </>
  );
}
